var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('report-preview-page',{attrs:{"title":_vm.pageTitle}},[(_vm.focusAreasContent)?_c('display-markdown',{staticClass:"pb-1",attrs:{"value":_vm.focusAreasContent}}):_vm._e(),(_vm.previewContent)?_c('display-markdown',{attrs:{"value":_vm.previewContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }